// extracted by mini-css-extract-plugin
export default {"backdrop":"CookieBanner_backdrop__uUNYJ","banner":"CookieBanner_banner__Nn3pE","button":"CookieBanner_button__4e+5B"};